import * as types from 'store/actions/types';
import produce from 'immer';

//  Import helpers
import { VOD_GENRES_TYPE } from 'components/helpers/genres_helpers/helpers';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		page: 0,
		total_results: 0,
		startIndex: 0,
		sorted: undefined,
		filters: {
			query: '',
			type: VOD_GENRES_TYPE,
			filterUrlQuery: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_PANEL_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH CATEGORIES ***************
			case types.FETCH_CATEGORIES_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_CATEGORIES_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				draft.options.startIndex = action.payload.startIndex;
				draft.options.page = action.payload.page;
				return;

			case types.FETCH_CATEGORIES_ERROR:
				draft.error = action.payload;
				return;

			// *************** DELETE CATEGORY ***************
			case types.DELETE_CATEGORY_LOADING:
				draft.deleteItem.success = false;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_CATEGORY_SUCCESS:
				draft.deleteItem.success = action.payload;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_CATEGORY_ERROR:
				draft.deleteItem.error = action.payload;
				return;

			// *************** SAVE SORTING OPTIONS ***************
			case types.SAVE_CATEGORIES_TABLE_SORTING:
				draft.options.sorted = action.payload;
				break;

			// *************** SET SEARCH QUERY ***************
			case types.SET_CATEGORIES_SEARCH_QUERY:
				draft.options.filters.query = action.payload;
				return;

			// *************** SET CATEGORIES TYPE ***************
			case types.SET_CATEGORIES_TYPE:
				draft.options.filters.type = action.payload;
				return;

			// *************** REMOVE CATEGORY ITEM ***************
			case types.REMOVE_CATEGORY_ITEM:
				draft.data = draft.data.filter((item) => item.id !== action.payload);
				return;

			// --------------- FILTERS ---------------
			// *************** SET FILTER URL QUERY ***************
			case types.SET_FILTER_URL_QUERY:
				draft.options.filters.filterUrlQuery = action.payload;
				break;

			// *************** CLEAR FILTERS ***************
			case types.CLEAR_FILTERS:
				draft.options.filters.filterUrlQuery = '';
				break;

			default:
				return state;
		}
	});
